module.exports = __webpack_public_path__ + "img/8.fdaa903.png";